// External
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { UiFormModule } from '../../../../common/components/ui/ui-form/ui-form.module';
import { UiCardModule } from '../../../../common/components/ui/ui-card/ui-card.module';
import { PipesModule } from '../../../../common/pipes/pipes.module';
import { PrivacyBreachComponent } from './privacy-breach.component';
import { DirectivesModule } from '../../../../common/components/directives.module';
import { UiDropdownModule } from '../../../../common/components/ui/ui-dropdown/ui-dropdown.module';
import { UiIconModule } from '../../../../common/components/ui/ui-icon/ui-icon.module';
import { UiPopoverModule } from '../../../../common/components/ui/ui-popover/ui-popover.module';
import { PrivacyFeedbackModule } from '../../privacy-feedback/privacy-feedback.module';


@NgModule({
    declarations: [
        PrivacyBreachComponent
    ],
    imports: [
        CommonModule,
        UiFormModule,
        TranslateModule,
        UiCardModule,
        FormsModule,
        PipesModule,
        DirectivesModule,
        UiDropdownModule,
        UiIconModule,
        UiPopoverModule,
        PrivacyFeedbackModule
    ],
    
    exports: [ PrivacyBreachComponent ]
    
})

export class PrivacyBreachModule {}
